import { AlertType } from "../../enums/AlertType";
import { Alert } from "../../interfaces/Alert";

export const ALERT_EVENT_ADDED_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translated: false,
  },
  message: {
    message: 'custom.event_added',
    translated: true,
  },
};
